import { Grid, Typography } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const UserPhoneNumber = ({ label, value, onChange }) => {
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Typography
        sx={{ fontFamily: "Inter", fontSize: "0.8rem", fontWeight: "bold" }}
      >
        {label}:
      </Typography>
      <PhoneInput
        preferredCountries={["cl", "us", "co"]}
        country={"cl"}
        placeholder="Numero de celular"
        value={value}
        onChange={onChange}
        autoFormat
        enableSearch
      />
    </Grid>
  );
};

export default UserPhoneNumber;
